/* Zamiennik tapandaDeepExtend(...) dla opcji sliderów — elementy DOM (nextEl/prevEl)
   nie są plain-object, więc przechodzą przez referencję, jak w jQuery. */
function tapandaDeepExtend(target) {
  for (var a = 1; a < arguments.length; a++) {
    var source = arguments[a];
    if (!source) continue;
    for (var key in source) {
      if (!Object.prototype.hasOwnProperty.call(source, key)) continue;
      var value = source[key];
      if (value === undefined) continue;
      var isPlain = value && typeof value === 'object' &&
        (Object.getPrototypeOf(value) === Object.prototype || Object.getPrototypeOf(value) === null);
      if (isPlain) {
        var existing = target[key];
        if (!existing || typeof existing !== 'object') existing = {};
        target[key] = tapandaDeepExtend(existing, value);
      } else {
        target[key] = value;
      }
    }
  }
  return target;
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="AccessibleNav"] .sub-menu-block').forEach((subMenu) => {
  subMenu.setAttribute('role', 'menu');
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.currentTarget.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);    
    const IncValue = this.input.value;
    // console.log("QTY"+IncValue);
    var priceElement =  document.querySelector('.product__info-container');
    var priceElementDIV = document.querySelector('.price-wrapper');
    if(!priceElementDIV) return;
    var currentPrice =  priceElement.querySelector('.product-price-current');   
    const priceData = currentPrice.dataset.price;   
    var SubPrice = priceData.replace(/[^0-9\.]/g, '');   
    var ReultPrice =  SubPrice.replace(/^(\.+)/g, '');     
    var EvalPrice = parseInt(ReultPrice)    
    var subtotal = (IncValue * EvalPrice);                      
    var subtotalElement =  document.getElementById('subtotal-value');    
    if(!subtotalElement) return;
    subtotalElement.textContent  = Shopify.formatMoney(subtotal+'.00', DT_THEME.moneyFormat);        
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function normalizeTapandaConsentFlag(value) {
  if (value === true || value === 'true' || value === 'yes' || value === 'granted' || value === 1 || value === '1') return true;
  return false;
}

function mapShopifyVisitorConsent(rawConsent) {
  if (!rawConsent || typeof rawConsent !== 'object') return null;

  const isProcessingState = [
    'preferencesAllowed',
    'preferencesProcessingAllowed',
    'analyticsAllowed',
    'analyticsProcessingAllowed',
    'marketingAllowed',
    'saleOfDataAllowed'
  ].some(function(key) {
    return Object.prototype.hasOwnProperty.call(rawConsent, key);
  });

  const preferencesValue = Object.prototype.hasOwnProperty.call(rawConsent, 'preferencesAllowed')
    ? rawConsent.preferencesAllowed
    : rawConsent.preferencesProcessingAllowed;
  const analyticsValue = Object.prototype.hasOwnProperty.call(rawConsent, 'analyticsAllowed')
    ? rawConsent.analyticsAllowed
    : rawConsent.analyticsProcessingAllowed;

  return {
    source: isProcessingState ? 'shopify_customer_privacy_event' : 'shopify_customer_privacy_decision',
    necessary: true,
    preferences: normalizeTapandaConsentFlag(
      isProcessingState ? preferencesValue : rawConsent.preferences
    ),
    analytics: normalizeTapandaConsentFlag(
      isProcessingState ? analyticsValue : rawConsent.analytics
    ),
    marketing: normalizeTapandaConsentFlag(
      isProcessingState ? rawConsent.marketingAllowed : rawConsent.marketing
    ),
    saleOfData: normalizeTapandaConsentFlag(
      isProcessingState ? rawConsent.saleOfDataAllowed : rawConsent.sale_of_data
    )
  };
}

function readShopifyConsentState() {
  const api = window.Shopify && window.Shopify.customerPrivacy;
  if (!api) return null;

  try {
    if (
      typeof api.preferencesProcessingAllowed === 'function' &&
      typeof api.analyticsProcessingAllowed === 'function' &&
      typeof api.marketingAllowed === 'function'
    ) {
      return {
        source: 'shopify_customer_privacy_processing',
        necessary: true,
        preferences: api.preferencesProcessingAllowed() === true,
        analytics: api.analyticsProcessingAllowed() === true,
        marketing: api.marketingAllowed() === true,
        saleOfData: typeof api.saleOfDataAllowed === 'function' ? api.saleOfDataAllowed() === true : false
      };
    }

    if (typeof api.currentVisitorConsent === 'function') {
      return mapShopifyVisitorConsent(api.currentVisitorConsent());
    }
  } catch (error) {
    // Fall through to the conservative no-consent state.
  }

  return null;
}

function consentStatesEqual(a, b) {
  if (!a && !b) return true;
  if (!a || !b) return false;
  return a.preferences === b.preferences &&
    a.analytics === b.analytics &&
    a.marketing === b.marketing &&
    a.saleOfData === b.saleOfData;
}

function dispatchTapandaConsentUpdated(consent) {
  try {
    window.dispatchEvent(new CustomEvent('tapanda:consent-updated', { detail: consent || null }));
  } catch (error) {
    // no-op
  }
}

function applyTapandaConsentState(consent, options = {}) {
  const previous = window.tapandaConsent && window.tapandaConsent.value ? window.tapandaConsent.value : null;
  const resolved = consent || null;
  window.tapandaConsent = {
    key: 'shopify_customer_privacy',
    value: resolved,
    canStorePreferences: function() {
      return !!(window.tapandaConsent && window.tapandaConsent.value && window.tapandaConsent.value.preferences === true);
    },
    hasCategory: function(category) {
      const normalizedCategory = (category || 'analytics').toLowerCase();
      if (normalizedCategory === 'necessary') return true;
      const state = window.tapandaConsent && window.tapandaConsent.value ? window.tapandaConsent.value : null;
      if (!state) return false;
      if (normalizedCategory === 'marketing') return state.marketing === true;
      if (normalizedCategory === 'preferences') return state.preferences === true;
      if (normalizedCategory === 'sale_of_data') return state.saleOfData === true;
      return state.analytics === true;
    }
  };

  if (options.silent !== true && !consentStatesEqual(previous, resolved)) {
    dispatchTapandaConsentUpdated(resolved);
  }
  return resolved;
}

function refreshTapandaConsentState(options = {}) {
  let consent = options.forcedConsent ? mapShopifyVisitorConsent(options.forcedConsent) : null;
  if (!consent) {
    consent = readShopifyConsentState();
  }
  return applyTapandaConsentState(consent, options);
}

function resolveTapandaConsentState() {
  // Re-read Shopify before every custom event so a withdrawn consent cannot
  // leave a stale, previously granted state in memory.
  return refreshTapandaConsentState({ silent: true });
}

function hasTapandaTrackingConsent(category) {
  const normalizedCategory = (category || 'analytics').toLowerCase();
  if (normalizedCategory === 'necessary') return true;
  const consent = resolveTapandaConsentState();
  if (!consent) return false;
  if (normalizedCategory === 'marketing') return consent.marketing === true;
  if (normalizedCategory === 'preferences') return consent.preferences === true;
  if (normalizedCategory === 'sale_of_data') return consent.saleOfData === true;
  return consent.analytics === true;
}

window.tapandaResolveConsentState = function() {
  return refreshTapandaConsentState({ silent: true });
};

document.addEventListener('visitorConsentCollected', function(event) {
  const detail = event && event.detail ? event.detail : null;
  refreshTapandaConsentState({ forcedConsent: detail });
});

document.addEventListener('shopify:customer_privacy:visitor_consent_collected', function(event) {
  const detail = event && event.detail ? event.detail : null;
  refreshTapandaConsentState({ forcedConsent: detail });
});

document.addEventListener('shopifyCustomerPrivacyApiLoaded', function() {
  refreshTapandaConsentState();
});

function isTapandaConsentDecisionAvailable(consent) {
  if (!consent || typeof consent !== 'object') return false;
  return ['preferences', 'analytics', 'marketing'].some(function(key) {
    return consent[key] === true || consent[key] === false;
  });
}

function openTapandaConsentPreferences() {
  const api = window.Shopify && window.Shopify.customerPrivacy;
  if (api) {
    if (typeof api.showPreferences === 'function') {
      api.showPreferences();
      return true;
    }
    if (typeof api.showConsentPreferences === 'function') {
      api.showConsentPreferences();
      return true;
    }
    if (typeof api.showBanner === 'function') {
      api.showBanner();
      return true;
    }
  }

  const fallbackSelectors = [
    '#shopify-pc__banner .shopify-pc__banner__btn-manage',
    '#shopify-pc__banner .shopify-pc__banner__btn-manage-prefs',
    '.shopify-pc__banner__btn-manage',
    '.shopify-pc__banner__btn-manage-prefs'
  ];

  for (let i = 0; i < fallbackSelectors.length; i += 1) {
    const target = document.querySelector(fallbackSelectors[i]);
    if (!target || typeof target.click !== 'function') continue;
    target.click();
    return true;
  }

  return false;
}

function setTapandaConsentManageVisibility() {
  const buttons = document.querySelectorAll('[data-tapanda-consent-manage]');
  if (!buttons.length) return;

  const state = resolveTapandaConsentState();
  const show = isTapandaConsentDecisionAvailable(state);

  buttons.forEach(function(button) {
    button.hidden = !show;
    button.setAttribute('aria-hidden', show ? 'false' : 'true');
  });
}

function initTapandaConsentManageButton() {
  const buttons = document.querySelectorAll('[data-tapanda-consent-manage]');
  if (!buttons.length) return;

  buttons.forEach(function(button) {
    if (button.dataset.tapandaConsentManageBound === 'true') return;
    button.dataset.tapandaConsentManageBound = 'true';
    button.addEventListener('click', function(event) {
      event.preventDefault();
      openTapandaConsentPreferences();
    });
  });

  setTapandaConsentManageVisibility();

  if (window.__tapandaConsentManageListenersBound) return;
  window.__tapandaConsentManageListenersBound = true;

  window.addEventListener('tapanda:consent-updated', function() {
    setTapandaConsentManageVisibility();
  });
  document.addEventListener('visitorConsentCollected', function() {
    setTapandaConsentManageVisibility();
  });
  document.addEventListener('shopify:customer_privacy:visitor_consent_collected', function() {
    setTapandaConsentManageVisibility();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    refreshTapandaConsentState({ silent: true });
    initTapandaConsentManageButton();
  });
} else {
  refreshTapandaConsentState({ silent: true });
  initTapandaConsentManageButton();
}

window.addEventListener('load', function() {
  refreshTapandaConsentState({ silent: true });
  initTapandaConsentManageButton();
});

if (!window.tapandaHasConsent) {
  window.tapandaHasConsent = function(category) {
    return hasTapandaTrackingConsent(category);
  };
}

function isTapandaAnalyticsEventName(eventName) {
  const normalizedEventName = String(eventName || '').trim();
  return normalizedEventName.indexOf('tapanda_') === 0 || normalizedEventName.indexOf('tapanda:') === 0;
}

// Explicit operator QA flag for this tab; no identifiers, consent changes or transport.
const tapandaQaVisit = (function() {
  const key = 'tapanda:qa-visit:v1';
  let enabled = false;
  let storageConfirmed = false;
  try {
    enabled = window.sessionStorage.getItem(key) === 'qa';
    storageConfirmed = true;
  } catch (error) {
    // Storage can be unavailable; an explicit enable still works for this page.
  }
  function getState() {
    return { enabled: enabled, storageConfirmed: storageConfirmed };
  }
  return Object.freeze({
    getState: getState,
    setEnabled: function(value) {
      if (typeof value !== 'boolean') throw new TypeError('QA flag requires a boolean');
      if (value) enabled = true;
      try {
        if (value) window.sessionStorage.setItem(key, 'qa');
        else window.sessionStorage.removeItem(key);
        enabled = value;
        storageConfirmed = true;
      } catch (error) {
        // Keep QA enabled if removing its persisted flag failed.
        storageConfirmed = false;
      }
      return getState();
    }
  });
})();
window.tapandaQaVisit = tapandaQaVisit;

if (!window.tapandaTrack) {
  window.tapandaTrack = function(eventName, detail, options) {
    const normalizedEventName = String(eventName || '').trim();
    if (!isTapandaAnalyticsEventName(normalizedEventName)) return false;

    const trackingCategory = options && options.category ? options.category : 'analytics';
    if (!hasTapandaTrackingConsent(trackingCategory)) return false;

    const payload = Object.assign({}, detail || {}, {
      event: normalizedEventName,
      tapanda_visit_type: tapandaQaVisit.getState().enabled ? 'qa' : 'customer'
    });
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(payload);
    }
    try {
      window.dispatchEvent(new CustomEvent(normalizedEventName, { detail: payload }));
    } catch (error) {
      // no-op
    }
    return true;
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
    
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    var menuDrawer = document.getElementById('menu-drawer');
    if (menuDrawer) {
      menuDrawer.style.top = '0';
    }
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      const mobileViewport = window.matchMedia('(max-width: 990px)');
      if (mobileViewport.matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.documentElement.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('overflow-hidden');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.documentElement.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove('overflow-hidden');
    removeTrapFocus(elementToFocus || this.mainDetailsToggle.querySelector('summary'));
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.documentElement.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('overflow-hidden');
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event || new Event('click'), elementToFocus || this.mainDetailsToggle.querySelector('summary'));
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);


class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
       if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {  
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);


class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.slider = this.querySelector('[data-slider-options]');
    this.init();
  }

  init() {
    const predefine = {
      effect: 'slide',
      direction: 'horizontal',
      autoplay: true,
      autoplaySpeed: 5,
      space: 0,
      center: true,
      options: {},
    };    
    const slider_options = this.slider.getAttribute('data-slider-options');
    if (slider_options === null || slider_options === '') {
      return null;
    }
    const grouping = tapandaDeepExtend(predefine, JSON.parse(slider_options));
    
    const isNumberic = /^\d+$/;
    Object.keys(grouping).forEach((key) => {
      if (typeof grouping[key] === 'string' && isNumberic.test(grouping[key])) {
        grouping[key] = parseInt(grouping[key], 10);
      }
    });
    let autoplay = false;
    if (grouping.auto_play > 0) {
      autoplay = {
        delay: grouping.auto_play * 1000,
      };
    }
    let loop = false;
    if (grouping.loop === 'true' || grouping.loop === true) {
      loop = true;
    }
    const option = tapandaDeepExtend({
      init: false,
      spaceBetween: 0,
      loop,
      autoplay,
      speed: 2000,
      navigation: {
        nextEl: this.slider.querySelector('.swiper-button-next'),
        prevEl: this.slider.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.slider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      lazy: true,
      effect: grouping.effect,
    }, grouping.options);
    const container = this.slider.querySelector('[data-swiper-slider]');
    const initiate = new Swiper(container, option);
    initiate.on('init', () => {
    initiate.update();
    });
    initiate.init();
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();    
    this.updateVariantStatuses();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  } 
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
   // window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];    
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);      
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        console.log(input.getAttribute('value'));
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }
  updatePickupAvailability() {     
  const pickUpAvailability = document.querySelector('pickup-availability');
  const notifyStatus = document.getElementById(`notify-block-${this.dataset.section}`);    
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {   
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
      if (notifyStatus) notifyStatus.classList.add('visibility-hidden');
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';      
    }
  }

  
  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);        
        if (source && destination) destination.innerHTML = source.innerHTML;
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

          const stockMessageSource = html.getElementById(`dt-stock-message-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
           const stockMessageDestination = document.getElementById(`dt-stock-message-${this.dataset.section}`);
        
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
        //  skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

         if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);

       if (stockMessageSource && stockMessageDestination) stockMessageDestination.innerHTML = stockMessageSource.innerHTML;

       const stickyDestination = document.getElementById(`sticky-price-${this.dataset.section}`);
       const stickySource = html.getElementById(`sticky-price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
         if (stickySource && stickyDestination) stickyDestination.innerHTML = stickySource.innerHTML;
        
        const stickyPrice = document.getElementById(`sticky-price-${this.dataset.section}`); 
        if (stickyPrice) stickyPrice.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const subTotal = document.getElementById(`subtotal-${this.dataset.section}`);
        const destination2 = document.getElementById(`subtotal-${this.dataset.section}`);
        const source2 = html.getElementById(`subtotal-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source2 && destination2) destination2.innerHTML = source2.innerHTML;

        if (inventoryDestination)
        inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
     const stickButton = document.getElementById('sticky-bar-button');
    
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
   
    
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    
    
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');    
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');      
      addButtonText.textContent = window.variantStrings.addToCart;
    }

     if (!stickButton) return;    
    if (disable) {      
      stickButton.setAttribute('disabled', 'disabled');      
    } else {      
      stickButton.removeAttribute('disabled');      
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`); 
    const stickyPrice = document.getElementById(`sticky-price-${this.dataset.section}`);    
    const notifyStatus = document.getElementById(`notify-block-${this.dataset.section}`);
   const inventory = document.getElementById(`Inventory-${this.dataset.section}`);    
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;        
  //  if (sku) sku.classList.add('visibility-hidden');
    if (notifyStatus) notifyStatus.classList.remove('visibility-hidden');
    if (!inventory) return;
    if (inventory) inventory.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }
  
 setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');            
      } else {
        input.classList.add('disabled');
      }
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {            
      fieldset.querySelector('.append-options-values').lastChild.textContent = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;      
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;      
    });
  }
}

customElements.define('variant-radios', VariantRadios);
class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector("[data-slider-options]");
        this.init();
    }

    init() {
        const sliderOptions = this.slider.getAttribute("data-slider-options");
        if (!sliderOptions || sliderOptions === "") return null;

        const options = JSON.parse(sliderOptions);
        const defaultOptions = {
            effect: "slide",
            direction: "horizontal",
            autoplay: false, 
            space: 30,
            center: true, 
            loop: true,
            initialSlide: 1, 
            options: {}
        };

        const mergedOptions = {
            ...defaultOptions,
            ...options
        };

        Object.keys(mergedOptions).forEach(key => {
            if (typeof mergedOptions[key] === "string" && /^\d+$/.test(mergedOptions[key])) {
                mergedOptions[key] = parseInt(mergedOptions[key], 10);
            }
        });

        const swiperConfig = {
            init: false,
            spaceBetween: mergedOptions.space,
            loop: true, 
            preventClicks: true,
            preventClicksPropagation: true,
            centeredSlides: mergedOptions.center,
            initialSlide: mergedOptions.initialSlide, 
            navigation: {
                nextEl: this.slider.querySelector(".swiper-button-next"),
                prevEl: this.slider.querySelector(".swiper-button-prev")
            },
            pagination: {
                el: this.slider.querySelector(".swiper-pagination"),
                clickable: true
            },
            lazy: true,
            focusableElements: 'input, select, option, textarea, video, label',
            breakpoints: {
                320: {
                    slidesPerView: mergedOptions.mobile,
                    spaceBetween: 0.5 * mergedOptions.space,
                    slidesPerColumn: 1
                },
                577: {
                    slidesPerView: mergedOptions.tablet,
                    slidesPerColumn: 1
                },
                781: {
                    slidesPerView: mergedOptions.laptop,
                    slidesPerColumn: 1
                },
                1200: {
                    slidesPerView: mergedOptions.desktop,
                    slidesPerColumn: 1
                }
            }
        };

        // Merge custom options into swiperConfig
        Object.assign(swiperConfig, mergedOptions.options);

        // Initialize Swiper
        const swiperContainer = this.slider.querySelector("[data-swiper-slider]");
        const swiperInstance = new Swiper(swiperContainer, swiperConfig);

        swiperInstance.on("init", () => {
            swiperInstance.update();
        });

        swiperInstance.init();
    }
}

customElements.define('swiper-slider', SwiperSlider);

class quoteSlider extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector("[data-slider-options]");
        this.init();
    }

    init() {
        const sliderOptions = this.slider.getAttribute("data-slider-options");
        if (!sliderOptions || sliderOptions === "") return null;

        const options = JSON.parse(sliderOptions);
        const defaultOptions = {
            effect: "slide",
            direction: "horizontal",
            autoplay: false, 
            space: 15,
            center: true, 
            loop: true,
            initialSlide: 1, 
            options: {}
        };

        const mergedOptions = {
            ...defaultOptions,
            ...options
        };

        Object.keys(mergedOptions).forEach(key => {
            if (typeof mergedOptions[key] === "string" && /^\d+$/.test(mergedOptions[key])) {
                mergedOptions[key] = parseInt(mergedOptions[key], 10);
            }
        });

        const swiperConfig = {
           // init: false,
            spaceBetween: mergedOptions.space,
            loop: true, 
            preventClicks: true,
            preventClicksPropagation: true,
            centeredSlides: mergedOptions.center,
          //  initialSlide: mergedOptions.initialSlide, 
            // freeMode: true,
            navigation: {
                nextEl: this.slider.parentElement.querySelector(".swiper-button-next"),
                prevEl: this.slider.parentElement.querySelector(".swiper-button-prev")
            },
            pagination: {
                el: this.slider.querySelector(".swiper-pagination"),
                clickable: true
            },
            lazy: true,
            focusableElements: 'input, select, option, textarea, video, label',
            speed: 3000,
            breakpoints: {
                320: {
                    slidesPerView: mergedOptions.mobile,
                    spaceBetween: 0.5 * mergedOptions.space,
                    slidesPerColumn: 1
                },
                577: {
                    slidesPerView: mergedOptions.tablet,
                    slidesPerColumn: 1,
                    centeredSlides: false
                },
                781: {
                    slidesPerView: mergedOptions.laptop,
                    slidesPerColumn: 1
                },
                1200: {
                    slidesPerView: mergedOptions.desktop,
                    slidesPerColumn: 1
                }
            }
        };

        // Merge custom options into swiperConfig
        Object.assign(swiperConfig, mergedOptions.options);

        // Initialize Swiper
        const swiperContainer = this.slider.querySelector("[data-swiper-slider]");
        const swiperInstance = new Swiper(swiperContainer, swiperConfig);

        swiperInstance.on("init", () => {
            swiperInstance.update();
        });

        swiperInstance.init();
    }
}

customElements.define('quote-slider', quoteSlider);
class BrandSlider extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector("[data-slider-options]");
        this.init();
    }

    init() {
        const sliderOptions = this.slider.getAttribute("data-slider-options");
        if (!sliderOptions || sliderOptions === "") return null;

        const options = JSON.parse(sliderOptions);
         let autoplay = false;
          if (options.auto_play > 0) {
            autoplay = {
              delay: options.auto_play * 1000,
            };
          }
        const defaultOptions = {
            effect: "slide",
            direction: "horizontal",
            autoplay,
            space: 30,
            center: false,
            loop: true,
            options: {}
        };

        // Parse options and ensure numeric values are correctly parsed
        Object.keys(options).forEach(key => {
            if (typeof options[key] === "string" && /^\d+$/.test(options[key])) {
                options[key] = parseInt(options[key], 10);
            }
        });

        const swiperConfig = {
            init: false,
            effect: options.effect || defaultOptions.effect,
            direction: options.direction || defaultOptions.direction,
            autoplay: options.autoplay || defaultOptions.autoplay,
            spaceBetween: options.space || defaultOptions.space,
            loop: options.loop === undefined ? defaultOptions.loop : options.loop,
            preventClicks: true,
            preventClicksPropagation: true,
            slidesPerView: 'auto',
            centeredSlides: options.center || defaultOptions.center,
            navigation: {
                nextEl: this.slider.querySelector(".swiper-button-next"),
                prevEl: this.slider.querySelector(".swiper-button-prev")
            },
            pagination: {
                el: this.slider.querySelector(".swiper-pagination"),
                clickable: true
            },
            lazy: true,
            focusableElements: 'input, select, option, textarea, video, label',
            breakpoints: {
                320: {
                    slidesPerView: options.mobile || defaultOptions.mobile,
                    spaceBetween: 0.5 * (options.space || defaultOptions.space),
                    slidesPerColumn: 1
                },
                577: {
                    slidesPerView: options.tablet || defaultOptions.tablet,
                    slidesPerColumn: 1
                },
                781: {
                    slidesPerView: options.laptop || defaultOptions.laptop,
                    slidesPerColumn: 1
                },
                1200: {
                    slidesPerView: options.desktop || defaultOptions.desktop,
                    slidesPerColumn: 1
                }
            }
        };

        // Initialize Swiper
        const swiperContainer = this.slider.querySelector("[data-swiper-slider]");
        const swiperInstance = new Swiper(swiperContainer, swiperConfig);

        // Pause autoplay on mouseenter
        swiperContainer.addEventListener('mouseenter', () => {
            swiperInstance.autoplay.stop();
        });

        // Resume autoplay on mouseleave
        swiperContainer.addEventListener('mouseleave', () => {
            swiperInstance.autoplay.start();
        });

        swiperInstance.on("init", () => {
            swiperInstance.update();
        });

        swiperInstance.init();
    }
}

customElements.define('brand-slider', BrandSlider);


class FeaturedSwiperSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = tapandaDeepExtend({
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                autoplay: s,
                preventClicks: true,
                preventClicksPropagation: true,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.parentElement.querySelector(".swiper-button-next"),
                    prevEl: this.slider.parentElement.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1,
                        spaceBetween: 15
                    },
                    576: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    781: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1,
                        spaceBetween: 28
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('featured-swiper-slider', FeaturedSwiperSlider);

class TestimonialVideoSwiperSlider extends HTMLElement {
       constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = tapandaDeepExtend({
                init: !1,
                spaceBetween: i.gap,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1,
                        spaceBetween: 15
                    },
                    481: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: i.laptop,
                        slidesPerColumn: 1
                    },
                    1541: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define('testimonial-video-swiper-slider', TestimonialVideoSwiperSlider);

class TeamSwiperSlider extends HTMLElement {
       constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = tapandaDeepExtend({
                init: !1,
                spaceBetween: i.gap,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1,
                        spaceBetween: 15
                    },
                    481: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: i.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define('team-swiper-slider', TeamSwiperSlider);

/*collection-list*/
class CollectionSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = tapandaDeepExtend({
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = tapandaDeepExtend({
                init: !1,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                effect: "coverflow",
                spaceBetween: 0,
                coverflowEffect: {
                    rotate: 0,
                    stretch: 0,
                    depth: 300,
                    modifier: 1,
                    slideShadows: !0
                },
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1
                    },
                    560: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    768: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                       
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-collection-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define("collection-slider", CollectionSlider);

class CollectionSwiperSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let l = !1;
        t.auto_play > 0 && (l = {
            delay: 1e3 * t.auto_play
        });
        let s = !1,
            o = !1;
        "true" === t.loop || !0 === t.loop ? s = !0 : 1 === t.loop ? (s = !0, o = !0) : (o = !1, s = !1);
        const r = tapandaDeepExtend({
                init: !1,
                spaceBetween: t.gap,
                loop: s,
                autoplay: l,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
          focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1,
                         spaceBetween: 10
                    },
                    576: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    990: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1440: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            p = new Swiper(n, r);
        p.on("init", (() => {
            p.update()
        })), p.init()
    }
}
customElements.define("collection-swiper-slider", CollectionSwiperSlider);
class Accordion {
    constructor(i) {
        this.el = i, this.summary = i.querySelector("summary"), this.content = i.querySelector(".accordion__content"), this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.summary.addEventListener("click", (i => this.onClick(i)))
    }
    onClick(i) {
        i.preventDefault(), this.el.style.overflow = "hidden", this.isClosing || !this.el.open ? this.open() : (this.isExpanding || this.el.open) && this.shrink()
    }
    shrink() {
        this.isClosing = !0;
        const i = `${this.el.offsetHeight}px`,
            t = `${this.summary.offsetHeight}px`;
        this.animation && this.animation.cancel(), this.animation = this.el.animate({
            height: [i, t]
        }, {
            duration: 400,
            easing: "ease-out"
        }), this.animation.onfinish = () => this.onAnimationFinish(!1), this.animation.oncancel = () => this.isClosing = !1
    }
    open() {
        this.el.style.height = `${this.el.offsetHeight}px`, this.el.open = !0, window.requestAnimationFrame((() => this.expand()))
    }
    expand() {
        this.isExpanding = !0;
        const i = `${this.el.offsetHeight}px`,
            t = `${this.summary.offsetHeight+this.content.offsetHeight}px`;
        this.animation && this.animation.cancel(), this.animation = this.el.animate({
            height: [i, t]
        }, {
            duration: 400,
            easing: "ease-out"
        }), this.animation.onfinish = () => this.onAnimationFinish(!0), this.animation.oncancel = () => this.isExpanding = !1
    }
    onAnimationFinish(i) {
        this.el.open = i, this.animation = null, this.isClosing = !1, this.isExpanding = !1, this.el.style.height = this.el.style.overflow = ""
    }
}
document.querySelectorAll(".dt-details").forEach((i => {
    new Accordion(i)
}));
function tapandaSlideUp(el, done) {
  el.style.height = el.scrollHeight + 'px';
  el.style.overflow = 'hidden';
  el.style.transition = 'height 0.3s ease';
  requestAnimationFrame(function () { el.style.height = '0px'; });
  window.setTimeout(function () {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition');
    if (done) done();
  }, 300);
}
function tapandaSlideDown(el) {
  el.style.display = 'block';
  var h = el.scrollHeight;
  el.style.height = '0px';
  el.style.overflow = 'hidden';
  el.style.transition = 'height 0.3s ease';
  requestAnimationFrame(function () { el.style.height = h + 'px'; });
  window.setTimeout(function () {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition');
  }, 300);
}
document.querySelectorAll('#accordian li').forEach(function (li) {
  li.addEventListener('click', function () {
    var rootUl = li.closest('ul');
    if (!rootUl) return;
    var wasActive = li.classList.contains('active');
    // listę aktywnych łapiemy PRZED animacją — szybkie podwójne kliknięcie nie
    // może zdjąć klasy z dopiero-co-aktywowanego li (semantyka oryginału jQuery)
    var actives = Array.prototype.slice.call(rootUl.querySelectorAll('.active'));
    var subLists = rootUl.querySelectorAll('ul');
    var pending = subLists.length;
    subLists.forEach(function (ul) {
      tapandaSlideUp(ul, function () {
        pending -= 1;
        if (pending === 0) {
          actives.forEach(function (n) { n.classList.remove('active'); });
        }
      });
    });
    if (!wasActive) {
      Array.prototype.forEach.call(li.children, function (child) {
        if (child.tagName === 'UL') tapandaSlideDown(child);
      });
      li.classList.add('active');
    }
  });
});

document.querySelectorAll('.footer-links .footer-block__heading, .footer_address .footer-block__heading').forEach(function (heading) {
  heading.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var block = heading.closest('.footer-links') || heading.closest('.footer_address');
    if (block) block.classList.toggle('open');
  });
});



class InstaSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = tapandaDeepExtend({
                init: !1,
                spaceBetween: i.gap,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: i.mobile,
                        slidesPerColumn: 1,
                        spaceBetween: 15
                    },
                    481: {
                        slidesPerView: i.tablet,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: i.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: i.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-insta-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define("insta-slider", InstaSlider);

class FlexSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        let e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        let i = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            t = /^\d+$/;
        Object.keys(i).forEach(e => {
            "string" == typeof i[e] && t.test(i[e]) && (i[e] = parseInt(i[e], 10))
        });
        let s = !1;
        i.auto_play > 0 && (s = {
            delay: 1e3 * i.auto_play
        });
        let l = !1,
            o = !1;
        "true" === i.loop || !0 === i.loop ? l = !0 : 1 === i.loop ? (l = !0, o = !0) : (o = !1, l = !1);
        let n = tapandaDeepExtend({
                init: !1,
                spaceBetween: 0,
                loop: l,
                autoplay: s,
                centeredSlides: o,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                breakpoints: {
                    320: {
                        slidesPerView: 2,
                        slidesPerColumn: 1,
                        centeredSlides: false,
                    },
                    560: {
                        slidesPerView: 3,
                        slidesPerColumn: 1,
                        centeredSlides: false,
                    },
                    990: {
                        slidesPerView: 4,
                        slidesPerColumn: 1
                    }
                }
            }, i.options),
            r = this.slider.querySelector("[data-flex-slider]"),
            a = new Swiper(r, n);
        a.on("init", () => {
            a.update()
        }), a.init()
    }
}
customElements.define("flex-slider", FlexSlider);


class RecommendationSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = tapandaDeepExtend({
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                autoplay: s,
                preventClicks: true,
                preventClicksPropagation: true,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    576: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    990: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1541: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('recommendation-slider', RecommendationSlider);




// let currentTabTitle = document.title
// document.addEventListener("visibilitychange", function () {	
// 	document.visibilityState === "hidden" ? (document.title = `Do not leave me 😭`): (document.title = currentTabTitle)
// })


class MultiSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = tapandaDeepExtend({
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                preventClicks: true,
          preventClicksPropagation: true,
                autoplay: s,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    577: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    991: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('multi-slider', MultiSlider);

class BlogSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = tapandaDeepExtend({
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                preventClicks: true,
          preventClicksPropagation: true,
                autoplay: s,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    577: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    990: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('blog-slider', BlogSlider);

class SupportSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = tapandaDeepExtend({
                init: !1,
                spaceBetween: t.gap,
                loop: l,
                preventClicks: true,
          preventClicksPropagation: true,
                autoplay: s,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    560: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1
                    },
                    992: {
                        slidesPerView: t.laptop,
                        slidesPerColumn: 1
                    },
                    1200: {
                        slidesPerView: t.desktop,
                        slidesPerColumn: 1
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('support-slider', SupportSlider);

class GridSlider extends HTMLElement {
    constructor() {
        super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
    }
    init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: true,
                loop: true,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = tapandaDeepExtend({
                init: !1,
                spaceBetween: t.gap,
                loop: false,
                spaceBetween: 30,
                preventClicks: true,
                preventClicksPropagation: true,
                autoplay: s,
                centeredSlides: false,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: t.mobile,
                        slidesPerColumn: 1
                    },
                    600: {
                        slidesPerView: t.tablet,
                        slidesPerColumn: 1,
                        centeredSlides: false,
                        
                    },
                    1200: {
                        slidesPerView: 3,
                        slidesPerColumn: 1,
                        spaceBetween: 30,
                    },
                    1350: {
                        slidesPerView: 3,
                        slidesPerColumn: 1,
                        spaceBetween: 50,
                    },
                    1540: {
                        slidesPerView: 3,
                        slidesPerColumn: 1,
                        spaceBetween: 75,
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('grid-slider', GridSlider);
/*Reveal*/
const isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
const revealObserverOptions = isMobileViewport
    ? { threshold: 0.01, rootMargin: '0px 0px 22% 0px' }
    : undefined;
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const hiddenElements = document.querySelectorAll('.shopify-section');
if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    hiddenElements.forEach((el) => {
        el.classList.add('reveal');
    });
} else {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting){
                entry.target.classList.add('reveal');
                observer.unobserve(entry.target);
            }
        });
    }, revealObserverOptions);
    hiddenElements.forEach((el) => {
        observer.observe(el);
    });
}


document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {  
   if(card.classList.contains('section-featured-collection') || card.classList.contains('section-collection-list')) {         
    const topHeading = card.querySelectorAll('.for-arrow-alignment');     
    if(topHeading.length === 0) return;
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';        
    const swiperContainer = card.querySelector('.swiper');    
    if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
      
  }        
});


document.querySelectorAll('[id^="block-tab-1"]').forEach((arrowTab, index) => {  
   if(arrowTab.classList.contains('product-tab-carousel')) {      
    const topHeading = arrowTab.querySelectorAll('.for-arrow-alignment'); 
    if(topHeading.length === 0) return;
    const cardHeight = parseInt(topHeading[0].clientHeight);    
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';    
    const swiperContainer = arrowTab.querySelector('.swiper-container');
    if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');
     if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});


class complementarySlider extends HTMLElement {
            constructor() {
                super(), this.slider = this.querySelector("[data-slider-options]"), this.init()
            }
            init() {
        const e = this.slider.getAttribute("data-slider-options");
        if (null === e || "" === e) return null;
        const t = tapandaDeepExtend({
                effect: "slide",
                direction: "horizontal",
                autoplay: !0,
                autoplaySpeed: 5,
                space: 30,
                center: !0,
                options: {}
            }, JSON.parse(e)),
            i = /^\d+$/;
        Object.keys(t).forEach((e => {
            "string" == typeof t[e] && i.test(t[e]) && (t[e] = parseInt(t[e], 10))
        }));
        let s = !1;
        t.auto_play > 0 && (s = {
            delay: 1e3 * t.auto_play
        });
        let l = !1,
            r = !1;
        "true" === t.loop || !0 === t.loop ? l = !0 : 1 === t.loop ? (l = !0, r = !0) : (r = !1, l = !1);
        const o = tapandaDeepExtend({
                init: !1,                
                loop: l,
                autoplay: s,
                preventClicks: true,
                preventClicksPropagation: true,
                centeredSlides: r,
                navigation: {
                    nextEl: this.slider.querySelector(".swiper-button-next"),
                    prevEl: this.slider.querySelector(".swiper-button-prev")
                },
                pagination: {
                    el: this.slider.querySelector(".swiper-pagination"),
                    clickable: !0
                },
                lazy: !0,
                focusableElements: 'input, select, option, textarea, video, label',
                breakpoints: {
                    320: {
                        slidesPerView: 1, 
                        spaceBetween: 10,
                    },
                    576: {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        spaceBetween: 20,
                    },
                    781: {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                        spaceBetween: 30,
                    },
                    1200: {
                        slidesPerView: 1,
                        slidesPerColumn: 1,
                         spaceBetween: 30,
                    }
                }
            }, t.options),
            n = this.slider.querySelector("[data-swiper-slider]"),
            a = new Swiper(n, o);
        a.on("init", (() => {
            a.update()
        })), a.init()
    }
}
customElements.define('complementary-slider', complementarySlider);


const copyText = document.getElementById('copy__text');
if (copyText !== null) {
const copyButton = copyText.querySelector("button");
if (copyButton) {
copyButton.addEventListener("click", function () {
let input = copyText.querySelector("input.text");
let couponCode = input ? input.value : "";
if (!couponCode) return;

const onCopied = function() {
  if (window.tapandaTrack) {
    window.tapandaTrack('tapanda_popup_cta_click', {
      source: 'flash_sale_banner',
      action: 'copy_code',
      code: couponCode
    });
  }
  copyText.classList.add("active");
  setTimeout(function () {
    copyText.classList.remove("active");
  }, 2500);
};

const fallbackCopy = function() {
  if (!input) return;
  input.select();
  document.execCommand("copy");
  window.getSelection().removeAllRanges();
  onCopied();
};

if (navigator.clipboard && window.isSecureContext) {
  navigator.clipboard.writeText(couponCode).then(onCopied).catch(fallbackCopy);
  return;
}

fallbackCopy();
});
}
}


class marqueeSwiper extends HTMLElement {
  constructor() {
   super();
   const marqueeContainer = this.querySelector('[id^="dt-marquee-section-"]'); 
   let speed = parseInt(marqueeContainer.getAttribute('data-speed'));        
    var mySwiper = new Swiper(marqueeContainer, {
    spaceBetween: 0,
    centeredSlides: true,
    speed: speed,      
    autoplay: {
       delay: 0,
         disableOnInteraction: false,
         pauseOnMouseEnter: true,
    },
    loop: true,
    slidesPerView:'auto',
    allowTouchMove: false    
    });   
    marqueeContainer.addEventListener('mouseenter', function() {
      document.querySelectorAll('.dt-animate-call').forEach(function (n) { n.classList.add('start-animation'); });
    });
    marqueeContainer.addEventListener('mouseleave', function() {
      document.querySelectorAll('.dt-animate-call').forEach(function (n) { n.classList.remove('start-animation'); });
    });
}
}
customElements.define('marquee-slider', marqueeSwiper);

/* === Login modal (a11y-aware) ===========================================
   Wave 1 (W1C): wire focus-trap, Escape, return focus, backdrop click and
   aria-expanded on the trigger so the dialog behaves like a real modal
   for keyboard / screen reader users.
   ======================================================================== */
const accountModel = document.getElementById('login-modal__window');
const accountButton = document.querySelector('.header__icon--account');
if (accountModel && accountButton) {
    const accountClose = accountModel.querySelector('.details-modal-close');
    let accountPreviousFocus = null;

    if (!accountButton.hasAttribute('aria-haspopup')) {
        accountButton.setAttribute('aria-haspopup', 'dialog');
    }
    if (!accountButton.hasAttribute('aria-controls')) {
        accountButton.setAttribute('aria-controls', 'login-modal__window');
    }
    accountButton.setAttribute('aria-expanded', 'false');

    function openAccountModal() {
        accountPreviousFocus = document.activeElement;
        accountModel.classList.add('login-modal-active');
        accountButton.setAttribute('aria-expanded', 'true');

        const initialTarget = accountModel.querySelector('input:not([type="hidden"]), button, [tabindex]:not([tabindex="-1"])') || accountModel;
        if (typeof trapFocus === 'function') {
            trapFocus(accountModel, initialTarget);
        } else if (initialTarget && typeof initialTarget.focus === 'function') {
            initialTarget.focus({ preventScroll: true });
        }
    }

    function closeAccountModal() {
        if (!accountModel.classList.contains('login-modal-active')) return;
        accountModel.classList.remove('login-modal-active');
        accountButton.setAttribute('aria-expanded', 'false');

        const returnTo = accountPreviousFocus && document.contains(accountPreviousFocus) ? accountPreviousFocus : accountButton;
        if (typeof removeTrapFocus === 'function') {
            removeTrapFocus(returnTo);
        } else if (returnTo && typeof returnTo.focus === 'function') {
            returnTo.focus({ preventScroll: true });
        }
        accountPreviousFocus = null;
    }

    accountButton.addEventListener('click', function (e) {
        e.preventDefault();
        if (accountModel.classList.contains('login-modal-active')) {
            closeAccountModal();
        } else {
            openAccountModal();
        }
    });

    if (accountClose) {
        accountClose.addEventListener('click', function (e) {
            e.preventDefault();
            closeAccountModal();
        });
    }

    accountModel.addEventListener('click', function (e) {
        if (e.target === accountModel) {
            closeAccountModal();
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' && e.keyCode !== 27) return;
        if (accountModel.classList.contains('login-modal-active')) {
            closeAccountModal();
        }
    });
}

(function initTapandaMicroFx() {
  if (window.__tapandaMicroFxInit) return;
  window.__tapandaMicroFxInit = true;

  var rootNode = document.documentElement;
  rootNode.classList.add('tapanda-microfx-ready');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver = null;
  var wowDelayScale = 0.08;
  var wowDelayMaxMs = 32;
  var finiteNumber = Number.isFinite || function (value) {
    return typeof value === 'number' && isFinite(value);
  };

  function parseDelayToMs(value) {
    if (typeof value !== 'string') return 0;
    var normalized = value.trim().toLowerCase();
    if (!normalized) return 0;

    if (normalized.indexOf('ms') !== -1) {
      var delayMs = parseFloat(normalized.replace('ms', '').trim());
      return finiteNumber(delayMs) && delayMs > 0 ? delayMs : 0;
    }

    if (normalized.indexOf('s') !== -1) {
      var delaySeconds = parseFloat(normalized.replace('s', '').trim());
      return finiteNumber(delaySeconds) && delaySeconds > 0 ? delaySeconds * 1000 : 0;
    }

    var rawDelay = parseFloat(normalized);
    return finiteNumber(rawDelay) && rawDelay > 0 ? rawDelay : 0;
  }

  function markVisibleImmediately(scope) {
    var targets = (scope || document).querySelectorAll('[data-microfx="reveal"]:not(.wow)');
    targets.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function markWowVisibleImmediately(scope) {
    var targets = (scope || document).querySelectorAll('.wow');
    targets.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function primeAutoRevealTargets(scope) {
    var context = scope || document;
    var autoTargets = context.querySelectorAll(
      '.product-grid .grid__item, .featured-collection .grid__item, .product-recommendations .swiper-slide, .collection-carousel3d .swiper-slide'
    );

    autoTargets.forEach(function (el) {
      if (!el.hasAttribute('data-microfx')) {
        el.setAttribute('data-microfx', 'reveal');
      }
    });
  }

  function observeRevealTargets(scope) {
    var context = scope || document;
    primeAutoRevealTargets(context);

    var targets = context.querySelectorAll('[data-microfx="reveal"]:not([data-microfx-bound]):not(.wow)');
    targets.forEach(function (el) {
      el.setAttribute('data-microfx-bound', 'true');
      el.style.setProperty('transition-delay', '0ms', 'important');
      if (reduceMotion || !revealObserver) {
        el.classList.add('is-visible');
      } else {
        revealObserver.observe(el);
      }
    });
  }

  function observeWowTargets(scope) {
    var context = scope || document;
    var targets = context.querySelectorAll('.wow:not([data-wow-bound])');

    targets.forEach(function (el) {
      el.setAttribute('data-wow-bound', 'true');
      var delayMs = parseDelayToMs(el.getAttribute('data-wow-delay') || '');
      if (delayMs > 0) {
        delayMs = Math.round(delayMs * wowDelayScale);
        if (delayMs > wowDelayMaxMs) {
          delayMs = wowDelayMaxMs;
        }
      }
      el.style.setProperty('transition-delay', delayMs + 'ms', 'important');

      if (reduceMotion || !revealObserver) {
        el.classList.add('is-visible');
      } else {
        revealObserver.observe(el);
      }
    });
  }

  if (!reduceMotion && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px 36% 0px'
    });
  }

  if (reduceMotion) {
    markVisibleImmediately(document);
    primeAutoRevealTargets(document);
    markVisibleImmediately(document);
    markWowVisibleImmediately(document);
  } else {
    observeRevealTargets(document);
    observeWowTargets(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sectionRoot = event && event.target ? event.target : document;
    if (reduceMotion) {
      primeAutoRevealTargets(sectionRoot);
      markVisibleImmediately(sectionRoot);
      markWowVisibleImmediately(sectionRoot);
      return;
    }
    observeRevealTargets(sectionRoot);
    observeWowTargets(sectionRoot);
  });
})();

/* Tapanda — menu drawer: O nas / Realizacje (działa także przy cache HTML) */
(function () {
  var SIDE_LINKS = [
    { href: '/pages/o-nas', text: 'O nas' },
    { href: '/pages/realizacje', text: 'Realizacje' }
  ];

  function collectSideLinks() {
    var links = [];
    var seen = {};
    document.querySelectorAll('.tapanda-header-side-menu__list a[href]').forEach(function (anchor) {
      var href = anchor.getAttribute('href') || '';
      var text = (anchor.textContent || '').trim();
      if (!href || !text || seen[href]) return;
      seen[href] = true;
      links.push({ href: href, text: text });
    });
    SIDE_LINKS.forEach(function (item) {
      if (!seen[item.href]) {
        links.push(item);
        seen[item.href] = true;
      }
    });
    return links;
  }

  function ensureDrawerSideMenu() {
    var drawer = document.getElementById('menu-drawer');
    if (!drawer) return;
    if (drawer.querySelector('.tapanda-drawer-side-menu')) return;

    var nav = drawer.querySelector('.menu-drawer__navigation');
    var mainMenu = drawer.querySelector('.menu-drawer__menu');
    if (!nav || !mainMenu) return;

    var links = collectSideLinks();
    if (!links.length) return;

    var ul = document.createElement('ul');
    ul.className = 'menu-drawer__menu list-menu tapanda-drawer-side-menu';
    ul.setAttribute('role', 'list');

    links.forEach(function (item) {
      var li = document.createElement('li');
      li.className = 'top-level-link dt-sc-child tapanda-drawer-side-nav';
      var a = document.createElement('a');
      a.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
      a.href = item.href;
      a.textContent = item.text;
      li.appendChild(a);
      ul.appendChild(li);
    });

    mainMenu.insertAdjacentElement('afterend', ul);
  }

  function bootDrawerSideMenu() {
    ensureDrawerSideMenu();
    var drawerToggle = document.querySelector('#Details-menu-drawer-container summary, header-drawer summary');
    if (drawerToggle && !drawerToggle.dataset.tpSideMenuBound) {
      drawerToggle.dataset.tpSideMenuBound = '1';
      drawerToggle.addEventListener('click', function () {
        window.setTimeout(ensureDrawerSideMenu, 0);
        window.setTimeout(ensureDrawerSideMenu, 120);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootDrawerSideMenu);
  } else {
    bootDrawerSideMenu();
  }
  document.addEventListener('shopify:section:load', bootDrawerSideMenu);
})();

/* Tapanda — karuzela realizacji (jednolity sterownik).
   RUCH STEROWANY rAF, BEZ animacji CSS. Wcześniej animacja CSS 0→-50% na
   zdublowanym torze (1.5 zestawu po duplikacji do 3 zestawów) powodowała
   „dojechanie do końca i cofnięcie". Teraz: pętla rAF z resetem o szerokość
   JEDNEGO zestawu (modulo) — nieskończone, płynne kółko w jednym kierunku.
   Ten skrypt zajmuje obie flagi (tpMarqueeReady + realMarqueeReady), więc
   pozostałe sterowniki (tapanda-realizations-marquee.js, skrypt sekcji)
   wstrzymują się i nie ma konfliktu transformacji. */
(function () {
  var STYLE_ID = 'tp-real-marquee-styles-global';
  var SPEED = 75; /* px na sekundę — łagodne, premium tempo */

  function injectMarqueeStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.tp-realizations-carousel--marquee{overflow:hidden!important;scroll-snap-type:none!important}' +
      '.tp-realizations-carousel__track{display:flex;align-items:stretch;gap:var(--tp-real-gap,12px);width:max-content;min-width:100%;will-change:transform}' +
      '.tp-realizations-carousel--marquee .tp-realizations-carousel__item{width:clamp(220px,42vw,340px)!important;flex:0 0 clamp(220px,42vw,340px)!important}';
    document.head.appendChild(style);
  }

  function initCarousel(carousel) {
    if (!carousel || carousel.dataset.tpMarqueeReady === '1') return;
    var section = carousel.closest('section[id^="RealizationsCarousel-"]');
    if (section && section.dataset.realMarqueeReady === '1') return;
    carousel.dataset.tpMarqueeReady = '1';
    if (section) section.dataset.realMarqueeReady = '1';
    injectMarqueeStyles();

    var track = carousel.querySelector('[data-real-track]');
    if (!track) {
      track = document.createElement('div');
      track.className = 'tp-realizations-carousel__track';
      track.setAttribute('data-real-track', '');
      while (carousel.firstChild) track.appendChild(carousel.firstChild);
      carousel.appendChild(track);
    }

    carousel.classList.add('tp-realizations-carousel--marquee');

    var originals = Array.prototype.slice.call(
      track.querySelectorAll(':scope > .tp-realizations-carousel__item:not(.tp-real-clone)')
    );
    if (originals.length < 2) return;

    function oneSetWidth() {
      var gap = parseInt(getComputedStyle(track).gap, 10) || 12;
      var w = 0;
      originals.forEach(function (n) { w += n.offsetWidth + gap; });
      return w;
    }

    if (track.dataset.duplicated !== '1') {
      var setW0 = oneSetWidth();
      var vpW = carousel.offsetWidth || 0;
      var setsNeeded = Math.max(2, Math.ceil((vpW * 2) / Math.max(setW0, 1)) + 1);
      for (var s = 0; s < setsNeeded; s++) {
        originals.forEach(function (node) {
          var clone = node.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('tp-real-clone');
          clone.querySelectorAll('a[href]').forEach(function (a) {
            a.setAttribute('tabindex', '-1');
          });
          track.appendChild(clone);
        });
      }
      track.dataset.duplicated = '1';
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    carousel.classList.add('is-playing');

    var offset = 0;
    var setW = oneSetWidth();
    var paused = false;
    var inView = true;
    var last = null;

    carousel.addEventListener('mouseenter', function () { paused = true; });
    carousel.addEventListener('mouseleave', function () { paused = false; });
    carousel.addEventListener('focusin', function () { paused = true; });
    carousel.addEventListener('focusout', function () { paused = false; });

    /* Mobile: palcem przesuwamy karuzelę ręcznie; pionowy gest oddajemy stronie (touch-action: pan-y),
       więc scroll strony nigdy nie jest blokowany, a poziomy swipe steruje marquee. */
    carousel.style.touchAction = 'pan-y';
    var dragging = false, dragStartX = 0, dragStartY = 0, dragBaseOffset = 0, horiz = false;
    carousel.addEventListener('touchstart', function (ev) {
      if (ev.touches.length !== 1) return;
      dragging = true; horiz = false;
      dragStartX = ev.touches[0].clientX;
      dragStartY = ev.touches[0].clientY;
      dragBaseOffset = offset;
      paused = true;
    }, { passive: true });
    carousel.addEventListener('touchmove', function (ev) {
      if (!dragging) return;
      var dx = ev.touches[0].clientX - dragStartX;
      var dy = ev.touches[0].clientY - dragStartY;
      if (!horiz && Math.abs(dx) < Math.abs(dy)) { dragging = false; paused = false; return; }
      horiz = true;
      offset = dragBaseOffset + dx;
      while (offset <= -setW) offset += setW;
      while (offset > 0) offset -= setW;
      track.style.transform = 'translate3d(' + offset + 'px,0,0)';
    }, { passive: true });
    function endRealDrag() { if (!dragging) return; dragging = false; last = null; setTimeout(function () { paused = false; }, 2000); }
    carousel.addEventListener('touchend', endRealDrag, { passive: true });
    carousel.addEventListener('touchcancel', endRealDrag, { passive: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { inView = e.isIntersecting; });
      }, { threshold: 0.02 });
      io.observe(carousel);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { setW = oneSetWidth(); }, 200);
    });

    function tick(ts) {
      if (last === null) last = ts;
      var dt = Math.min((ts - last) / 1000, 0.05);
      last = ts;
      if (!paused && inView && !document.hidden) {
        offset -= SPEED * dt;
        if (-offset >= setW) offset += setW; /* reset o jeden zestaw — bez skoku */
        track.style.transform = 'translate3d(' + offset + 'px,0,0)';
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initAllCarousels() {
    document.querySelectorAll('[data-real-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }
  window.addEventListener('load', initAllCarousels);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-real-carousel]').forEach(initCarousel);
  });
})();

/* Tapanda — scrim (przyciemnione tło) pod bocznym menu mobilnym.
   Panel menu ma ekstremalny z-index i wymyka się z lokalnego kontekstu, więc
   nakładkę dajemy jako element wstrzyknięty do <body> (z-index tuż pod panelem).
   Klik w scrim zamyka menu. Styl: .tp-menu-scrim w custom-v2.css. */
(function () {
  function initMenuScrim() {
    var details = document.querySelector('header-drawer details');
    if (!details || details.dataset.tpScrimReady === '1') return;
    details.dataset.tpScrimReady = '1';

    var scrim = document.createElement('div');
    scrim.className = 'tp-menu-scrim';
    scrim.setAttribute('aria-hidden', 'true');
    document.body.appendChild(scrim);

    function sync() {
      if (details.hasAttribute('open')) {
        scrim.classList.add('is-visible');
      } else {
        scrim.classList.remove('is-visible');
      }
    }

    details.addEventListener('toggle', sync);

    scrim.addEventListener('click', function () {
      if (!details.hasAttribute('open')) return;
      var summary = details.querySelector('summary');
      if (summary) {
        summary.click(); /* natywne zamknięcie + handlery header-drawer */
      } else {
        details.removeAttribute('open');
      }
    });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuScrim);
  } else {
    initMenuScrim();
  }
  document.addEventListener('shopify:section:load', initMenuScrim);
})();

;(() => {
'use strict';
const rollout = { exclusivePublisherConfirmed: true };
if (rollout.exclusivePublisherConfirmed !== true) return;
'use strict';

const MARKER = '__tapandaClarityConsentBridgeV1';

function installClarityConsentBridge({
  window: win,
  document: doc,
  exclusivePublisherConfirmed = false,
  setTimeout: timeout,
  clearTimeout: clear,
  now = Date.now,
  waitMs = 12000,
  pollMs = 100,
  maxSdkAttempts = 4,
  retryMs = 250,
} = {}) {
  const inactive = reason => ({
    installed: false,
    reason,
    sync: () => false,
    dispose: () => {},
    getStatus: () => ({ phase: 'blocked', lastError: reason, attempts: 0, pending: false }),
  });
  if (exclusivePublisherConfirmed !== true) {
    return inactive('exclusive_publisher_not_confirmed');
  }
  if (!win || !doc || typeof doc.addEventListener !== 'function' ||
      typeof doc.removeEventListener !== 'function') {
    return inactive('environment_unavailable');
  }
  if (win[MARKER]) return win[MARKER];

  const schedule = typeof timeout === 'function' ? timeout :
    typeof win.setTimeout === 'function' ? win.setTimeout.bind(win) : null;
  const cancel = typeof clear === 'function' ? clear :
    typeof win.clearTimeout === 'function' ? win.clearTimeout.bind(win) : null;
  const clock = typeof now === 'function' ? now : Date.now;
  const duration = Number.isFinite(waitMs) ? Math.min(12000, Math.max(0, waitMs)) : 12000;
  const interval = Number.isFinite(pollMs) ? Math.max(1, pollMs) : 100;
  const limit = Number.isFinite(maxSdkAttempts) ? Math.min(5, Math.max(1, Math.trunc(maxSdkAttempts))) : 4;
  const retryDelay = Number.isFinite(retryMs) ? Math.min(12000, Math.max(1, retryMs)) : 250;
  let timer = null;
  let deadline = 0;
  let disposed = false;
  let lastSdk = null;
  let lastKey = null;
  let phase = 'waiting_api';
  let lastError = null;
  let attempts = 0;

  function getStatus() {
    return { phase, lastError, attempts, pending: timer !== null };
  }

  function cancelPending() {
    if (timer !== null && cancel) cancel(timer);
    timer = null;
  }

  function readState() {
    const denied = { analytics_Storage: 'denied', ad_Storage: 'denied' };
    let api;
    try {
      api = win.Shopify && win.Shopify.customerPrivacy;
      if (!api || typeof api.currentVisitorConsent !== 'function') {
        return { state: denied, ready: false };
      }
    } catch {
      return { state: denied, ready: false };
    }
    let raw = null;
    try { raw = api.currentVisitorConsent(); } catch {
      return { state: denied, ready: false };
    }
    let ready = true;
    const category = (name, getter) => {
      try {
        const allowed = api[getter];
        if (typeof allowed !== 'function') {
          ready = false;
          return 'denied';
        }
        return raw && raw[name] === 'yes' && allowed.call(api) === true ? 'granted' : 'denied';
      } catch {
        ready = false;
        return 'denied';
      }
    };
    const state = {
      analytics_Storage: category('analytics', 'analyticsProcessingAllowed'),
      ad_Storage: category('marketing', 'marketingAllowed'),
    };
    return { state, ready };
  }

  function block(error) {
    cancelPending();
    phase = 'blocked';
    lastError = error;
    return false;
  }

  function wait(nextPhase, delay) {
    cancelPending();
    const remaining = deadline - clock();
    if (remaining <= 0) return block(lastError || 'readiness_timeout');
    if (!schedule || !cancel) return block(lastError || 'timer_unavailable');
    phase = nextPhase;
    timer = schedule(() => {
      timer = null;
      flush();
    }, Math.min(delay, remaining));
    return false;
  }

  function flush(initial = false) {
    if (disposed) return false;
    const { state, ready } = readState();
    let sdk;
    try { sdk = win.clarity; } catch {}
    if (!initial && clock() >= deadline) return block(lastError || 'readiness_timeout');
    if (typeof sdk !== 'function') {
      lastError = 'sdk_unavailable';
      return wait('waiting_sdk', interval);
    }
    const key = state.analytics_Storage + ':' + state.ad_Storage;
    if (sdk !== lastSdk || key !== lastKey) {
      if (attempts >= limit) return block('sdk_attempt_limit');
      attempts += 1;
      try {
        sdk.call(win, 'consentv2', state);
      } catch {
        lastSdk = null;
        lastKey = null;
        lastError = 'sdk_call_failed';
        if (attempts >= limit) return block(lastError);
        return wait('retrying_sdk', retryDelay * (2 ** (attempts - 1)));
      }
      lastSdk = sdk;
      lastKey = key;
      lastError = null;
    }
    if (!ready) {
      lastError = 'api_unavailable';
      return wait('waiting_api', interval);
    }
    cancelPending();
    phase = 'synced';
    lastError = null;
    return true;
  }

  function sync() {
    if (disposed) return false;
    cancelPending();
    attempts = 0;
    lastError = null;
    deadline = clock() + duration;
    return flush(true);
  }

  const onChange = () => sync();
  const domPending = doc.readyState === 'loading';
  const api = { installed: true, sync, dispose, getStatus };

  function dispose() {
    if (disposed) return;
    disposed = true;
    cancelPending();
    doc.removeEventListener('visitorConsentCollected', onChange);
    doc.removeEventListener('shopifyCustomerPrivacyApiLoaded', onChange);
    if (domPending) doc.removeEventListener('DOMContentLoaded', onChange);
    if (win[MARKER] === api) delete win[MARKER];
    lastSdk = null;
    lastKey = null;
    phase = 'disposed';
    api.installed = false;
  }

  win[MARKER] = api;
  doc.addEventListener('visitorConsentCollected', onChange);
  doc.addEventListener('shopifyCustomerPrivacyApiLoaded', onChange);
  if (domPending) doc.addEventListener('DOMContentLoaded', onChange);
  sync();
  return api;
}


installClarityConsentBridge({ window, document, exclusivePublisherConfirmed: rollout.exclusivePublisherConfirmed });
})();
